import { useContext, useEffect, useState } from 'react'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import UserContext from 'src/provider/state-manager/userProvider'
import ApiContext from 'src/provider/API/call-service'
import { AbsoluteContainer, AppSpan, AppText, Button, FlexColumn, FlexRow, Form, FormGroup, FormGroupWithIcon, ScreenContainer } from "src/style"
import { useNavigate } from 'react-router-dom'
import { FiChevronDown } from 'react-icons/fi'
import { IoArrowBackOutline } from 'react-icons/io5'
import { BsEyeSlash, BsEye } from 'react-icons/bs'


export const SecurityQuestionsD2: React.FC<any> = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info} = useContext(AppInfoContext)
    const {user: {onboardingInput}, setUserProperty} = useContext(UserContext)
    const [onboardingType, setOnboardingType] = useState(info.onboardingType)
    const [input, setInput] = useState({
        securityQuestion1: onboardingInput?.securityQuestion1 || '', securityAnswer1: onboardingInput.securityAnswer1 || '', 
        securityQuestion2: onboardingInput.securityQuestion2 || '', securityAnswer2: onboardingInput.securityAnswer2 || ''
    })
    const [allSecurityQuestions, setAllSecurityQuestions] = useState<any>(null)
    const [showAnswer, setShowAnswer] = useState({answer1: false, answer2: false})

    useEffect(() => {
        if (info.onboardingType) {
            setOnboardingType(info.onboardingType)
            handleFetchSecurityQuestions()
        }
    }, [info.onboardingType])

    async function handleFetchSecurityQuestions () {
        const response = await API.getSecurityQuestions()
        if (response) setAllSecurityQuestions(response)
    }

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleSubmit(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        
        await setUserProperty('onboardingInput', {...onboardingInput, ...input})
        if (onboardingType === 'new-user') navigate('/onboarding/referral')
        else {
            const response = await API.onboardCustomer(input)
            if (response) navigate('/onboarding/profile-setup-completion')
        }
    }

    return (
        <ScreenContainer padding='2.5' height='auto' sizeUnit=''>
            <FlexColumn 
                justifyContent='flex-start'
                className='onboarding-screen-container-d2'
            >
                <AppText 
                    textSize='3' color='#101828' 
                    bottomMargin='1' fontFamily='Gilmer-Bold'
                >
                    Security Question
                </AppText>
                <AppSpan>Please Create your Security Question & Answer</AppSpan>
                <Form topMargin='2.5' onSubmit={handleSubmit}>
                    <FormGroupWithIcon bottomMargin='2'>
                        <label>Security Question 1</label>
                        <div className='input-with-icon'>
                            <select 
                                name='securityQuestion1'
                                value={input.securityQuestion1}
                                style={{color: input.securityQuestion1 ? '#000000' : '#667085'}}
                                onChange={handleInput}
                                required
                            >
                                <option value="">Select Question</option>
                                {
                                    allSecurityQuestions?.map((item: any, index: number) => {
                                        return (
                                            <option 
                                                value={item.question} 
                                                key={index}
                                                disabled={item.question === input.securityQuestion2}
                                            >
                                                {item.question}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                            <FiChevronDown className="input-with-icon-tag" />
                        </div>
                    </FormGroupWithIcon>
                    <FormGroup>
                        <label>Security Answer 1</label>
                        <input 
                            type={showAnswer.answer1 ? 'text' : 'password'}
                            placeholder='Answer' 
                            name='securityAnswer1'
                            value={input.securityAnswer1}
                            onChange={handleInput}
                            autoComplete="off"
                            required
                        />
                        { !showAnswer.answer1 ?
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowAnswer({...showAnswer, answer1: true})}
                                >
                                    <BsEyeSlash/>
                                </AppSpan>
                            </AbsoluteContainer>
                            :
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowAnswer({...showAnswer, answer1: false})}
                                >
                                    <BsEye/>
                                </AppSpan>
                            </AbsoluteContainer>
                        }
                    </FormGroup>
                    <FormGroupWithIcon bottomMargin='2'>
                        <label>Security Question 2</label>
                        <div className='input-with-icon'>
                            <select 
                                name='securityQuestion2'
                                value={input.securityQuestion2}
                                style={{color: input.securityQuestion2 ? '#000000' : '#667085'}}
                                onChange={handleInput}
                                required
                            >
                                <option value="">Select Question</option>
                                {
                                    allSecurityQuestions?.map((item: any, index: number) => {
                                        return (
                                            <option 
                                                value={item.question} 
                                                key={index}
                                                disabled={item.question === input.securityQuestion1}
                                            >
                                                {item.question}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                            <FiChevronDown className="input-with-icon-tag" />
                        </div>
                    </FormGroupWithIcon>
                    <FormGroup>
                        <label>Security Answer 2</label>
                        <input
                            type={showAnswer.answer2 ? 'text' : 'password'}
                            placeholder='Answer' 
                            name='securityAnswer2'
                            value={input.securityAnswer2}
                            onChange={handleInput}
                            autoComplete="off"
                            required
                        />
                        { !showAnswer.answer2 ?
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowAnswer({...showAnswer, answer2: true})}
                                >
                                    <BsEyeSlash/>
                                </AppSpan>
                            </AbsoluteContainer>
                            :
                            <AbsoluteContainer bottom='1.2' right='1'>
                                <AppSpan 
                                    color='rgba(0, 0, 0, 0.5)' textSize='1.7' cursor='pointer'
                                    onClick={() => setShowAnswer({...showAnswer, answer2: false})}
                                >
                                    <BsEye/>
                                </AppSpan>
                            </AbsoluteContainer>
                        }
                    </FormGroup>
                    
                    <FlexRow justifyContent='flex-end' topMargin='1.5' gap='1.5'>
                        <Button 
                            width='9.3' height='4' bgColor="#ffffff"
                            borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                            hoverColor='#0D968F' titleSize='1.4' color="#344054"
                            childHoverColor='#0D968F' type="button"
                            onClick={() => navigate(-1)}
                        >
                            <AppSpan color='#344054' rightMargin='1' textSize='1.6'>
                                <IoArrowBackOutline/>
                            </AppSpan>
                            Back
                        </Button>
                        <Button 
                            width='8.8' height='4'
                            borderColor='#0D968F' hoverBgColor='#fff' 
                            hoverColor='#0D968F' titleSize='1.4'
                        >
                            Proceed
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </ScreenContainer>
    )
}
